// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { ButtonTokens } from './type';

const buttonTokens: ButtonTokens = {
  buttonSplitlineFullBackgroundColor: '#ffffff',
  buttonSplitlineOutlineBackgroundColor: 'Neutral-border-2',
  buttonPrimaryFontColor: 'Neutral-text-1',
  buttonPrimaryBackgroundColor: 'Brand-6',
  buttonPrimaryBorderColor: 'Brand-6',
  buttonPrimaryDisabledFontColor: 'Neutral-text-1',
  buttonPrimaryDisabledBackgroundColor: 'Brand-3',
  buttonPrimaryDisabledBorderColor: 'Brand-3',
  buttonPrimaryHoverFontColor: 'Neutral-text-1',
  buttonPrimaryHoverBackgroundColor: 'Brand-5',
  buttonPrimaryHoverBorderColor: 'Brand-5',
  buttonPrimaryActiveFontColor: 'Neutral-text-1',
  buttonPrimaryActiveBackgroundColor: 'Brand-7',
  buttonPrimaryActiveBorderColor: 'Brand-7',
  buttonPrimaryFocusFontColor: 'Neutral-text-1',
  buttonPrimaryFocusBackgroundColor: 'Brand-5',
  buttonPrimaryFocusBorderColor: 'Brand-5',
  buttonPrimaryOutlineFontColor: 'Brand-6',
  buttonPrimaryOutlineBackgroundColor: 'transparent',
  buttonPrimaryOutlineBorderColor: 'Brand-6',
  buttonPrimaryOutlineDisabledFontColor: 'Brand-3',
  buttonPrimaryOutlineDisabledBackgroundColor: 'transparent',
  buttonPrimaryOutlineDisabledBorderColor: 'Brand-3',
  buttonPrimaryOutlineHoverFontColor: 'Brand-5',
  buttonPrimaryOutlineHoverBackgroundColor: 'transparent',
  buttonPrimaryOutlineHoverBorderColor: 'Brand-5',
  buttonPrimaryOutlineActiveFontColor: 'Brand-7',
  buttonPrimaryOutlineActiveBackgroundColor: 'transparent',
  buttonPrimaryOutlineActiveBorderColor: 'Brand-7',
  buttonPrimaryOutlineFocusFontColor: 'Brand-5',
  buttonPrimaryOutlineFocusBackgroundColor: 'transparent',
  buttonPrimaryOutlineFocusBorderColor: 'Brand-5',
  buttonPrimaryTextFontColor: 'Brand-6',
  buttonPrimaryTextBackgroundColor: 'Transparent',
  buttonPrimaryTextBorderColor: 'Transparent',
  buttonPrimaryTextDisabledFontColor: 'Brand-3',
  buttonPrimaryTextDisabledBackgroundColor: 'Transparent',
  buttonPrimaryTextDisabledBorderColor: 'Transparent',
  buttonPrimaryTextHoverFontColor: 'Brand-6',
  buttonPrimaryTextHoverBackgroundColor: 'Neutral-fill-2',
  buttonPrimaryTextHoverBorderColor: 'Neutral-fill-2',
  buttonPrimaryTextActiveFontColor: 'Brand-6',
  buttonPrimaryTextActiveBackgroundColor: 'Neutral-fill-3',
  buttonPrimaryTextActiveBorderColor: 'Neutral-fill-3',
  buttonPrimaryTextFocusFontColor: 'Brand-6',
  buttonPrimaryTextFocusBackgroundColor: 'Neutral-fill-2',
  buttonPrimaryTextFocusBorderColor: 'Neutral-fill-2',
  buttonSecondaryFontColor: 'Neutral-text-5',
  buttonSecondaryBackgroundColor: 'Neutral-fill-2',
  buttonSecondaryBorderColor: 'Neutral-fill-2',
  buttonSecondaryDisabledFontColor: 'Neutral-text-2',
  buttonSecondaryDisabledBackgroundColor: 'Neutral-fill-2',
  buttonSecondaryDisabledBorderColor: 'Neutral-fill-2',
  buttonSecondaryHoverFontColor: 'Neutral-text-5',
  buttonSecondaryHoverBackgroundColor: 'Neutral-fill-3',
  buttonSecondaryHoverBorderColor: 'Neutral-fill-3',
  buttonSecondaryActiveFontColor: 'Neutral-text-5',
  buttonSecondaryActiveBackgroundColor: 'Neutral-fill-4',
  buttonSecondaryActiveBorderColor: 'Neutral-fill-4',
  buttonSecondaryFocusFontColor: 'Neutral-text-5',
  buttonSecondaryFocusBackgroundColor: 'Neutral-fill-4',
  buttonSecondaryFocusBorderColor: 'Neutral-fill-4',
  buttonSecondaryOutlineFontColor: 'Neutral-text-5',
  buttonSecondaryOutlineBackgroundColor: 'transparent',
  buttonSecondaryOutlineBorderColor: 'Neutral-border-2',
  buttonSecondaryOutlineDisabledFontColor: 'Neutral-text-2',
  buttonSecondaryOutlineDisabledBackgroundColor: 'transparent',
  buttonSecondaryOutlineDisabledBorderColor: 'Neutral-border-2',
  buttonSecondaryOutlineHoverFontColor: 'Brand-5',
  buttonSecondaryOutlineHoverBackgroundColor: 'transparent',
  buttonSecondaryOutlineHoverBorderColor: 'Brand-5',
  buttonSecondaryOutlineActiveFontColor: 'Brand-7',
  buttonSecondaryOutlineActiveBackgroundColor: 'transparent',
  buttonSecondaryOutlineActiveBorderColor: 'Brand-7',
  buttonSecondaryOutlineFocusFontColor: 'Brand-5',
  buttonSecondaryOutlineFocusBackgroundColor: 'transparent',
  buttonSecondaryOutlineFocusBorderColor: 'Brand-5',
  buttonSecondaryTextFontColor: 'Neutral-text-5',
  buttonSecondaryTextBackgroundColor: 'Transparent',
  buttonSecondaryTextBorderColor: 'Transparent',
  buttonSecondaryTextDisabledFontColor: 'Neutral-text-2',
  buttonSecondaryTextDisabledBackgroundColor: 'Transparent',
  buttonSecondaryTextDisabledBorderColor: 'Transparent',
  buttonSecondaryTextHoverFontColor: 'Neutral-text-5',
  buttonSecondaryTextHoverBackgroundColor: 'Neutral-fill-2',
  buttonSecondaryTextHoverBorderColor: 'Neutral-fill-2',
  buttonSecondaryTextActiveFontColor: 'Neutral-text-5',
  buttonSecondaryTextActiveBackgroundColor: 'Neutral-fill-3',
  buttonSecondaryTextActiveBorderColor: 'Neutral-fill-3',
  buttonSecondaryTextFocusFontColor: 'Neutral-text-5',
  buttonSecondaryTextFocusBackgroundColor: 'Neutral-fill-2',
  buttonSecondaryTextFocusBorderColor: 'Neutral-fill-2',
  buttonSuccessFontColor: 'Neutral-text-1',
  buttonSuccessBackgroundColor: 'Success-6',
  buttonSuccessBorderColor: 'Success-6',
  buttonSuccessDisabledFontColor: 'Neutral-text-1',
  buttonSuccessDisabledBackgroundColor: 'Success-3',
  buttonSuccessDisabledBorderColor: 'Success-3',
  buttonSuccessHoverFontColor: 'Neutral-text-1',
  buttonSuccessHoverBackgroundColor: 'Success-5',
  buttonSuccessHoverBorderColor: 'Success-5',
  buttonSuccessActiveFontColor: 'Neutral-text-1',
  buttonSuccessActiveBackgroundColor: 'Success-7',
  buttonSuccessActiveBorderColor: 'Success-7',
  buttonSuccessFocusFontColor: 'Neutral-text-1',
  buttonSuccessFocusBackgroundColor: 'Success-5',
  buttonSuccessFocusBorderColor: 'Success-5',
  buttonSuccessOutlineFontColor: 'Success-6',
  buttonSuccessOutlineBackgroundColor: 'transparent',
  buttonSuccessOutlineBorderColor: 'Success-6',
  buttonSuccessOutlineDisabledFontColor: 'Success-3',
  buttonSuccessOutlineDisabledBackgroundColor: 'transparent',
  buttonSuccessOutlineDisabledBorderColor: 'Success-3',
  buttonSuccessOutlineHoverFontColor: 'Success-5',
  buttonSuccessOutlineHoverBackgroundColor: 'transparent',
  buttonSuccessOutlineHoverBorderColor: 'Success-5',
  buttonSuccessOutlineActiveFontColor: 'Success-7',
  buttonSuccessOutlineActiveBackgroundColor: 'transparent',
  buttonSuccessOutlineActiveBorderColor: 'Success-7',
  buttonSuccessOutlineFocusFontColor: 'Success-5',
  buttonSuccessOutlineFocusBackgroundColor: 'transparent',
  buttonSuccessOutlineFocusBorderColor: 'Success-5',
  buttonSuccessTextFontColor: 'Success-6',
  buttonSuccessTextBackgroundColor: 'Transparent',
  buttonSuccessTextBorderColor: 'Transparent',
  buttonSuccessTextDisabledFontColor: 'Success-3',
  buttonSuccessTextDisabledBackgroundColor: 'Transparent',
  buttonSuccessTextDisabledBorderColor: 'Transparent',
  buttonSuccessTextHoverFontColor: 'Success-5',
  buttonSuccessTextHoverBackgroundColor: 'Neutral-fill-2',
  buttonSuccessTextHoverBorderColor: 'Neutral-fill-2',
  buttonSuccessTextActiveFontColor: 'Success-6',
  buttonSuccessTextActiveBackgroundColor: 'Neutral-fill-3',
  buttonSuccessTextActiveBorderColor: 'Neutral-fill-3',
  buttonSuccessTextFocusFontColor: 'Success-5',
  buttonSuccessTextFocusBackgroundColor: 'Neutral-fill-2',
  buttonSuccessTextFocusBorderColor: 'Neutral-fill-2',
  buttonWarningFontColor: 'Neutral-text-1',
  buttonWarningBackgroundColor: 'Warning-6',
  buttonWarningBorderColor: 'Warning-6',
  buttonWarningDisabledFontColor: 'Neutral-text-1',
  buttonWarningDisabledBackgroundColor: 'Warning-3',
  buttonWarningDisabledBorderColor: 'Warning-3',
  buttonWarningHoverFontColor: 'Neutral-text-1',
  buttonWarningHoverBackgroundColor: 'Warning-5',
  buttonWarningHoverBorderColor: 'Warning-5',
  buttonWarningActiveFontColor: 'Neutral-text-1',
  buttonWarningActiveBackgroundColor: 'Warning-7',
  buttonWarningActiveBorderColor: 'Warning-7',
  buttonWarningFocusFontColor: 'Neutral-text-1',
  buttonWarningFocusBackgroundColor: 'Warning-5',
  buttonWarningFocusBorderColor: 'Warning-5',
  buttonWarningOutlineFontColor: 'Warning-6',
  buttonWarningOutlineBackgroundColor: 'transparent',
  buttonWarningOutlineBorderColor: 'Warning-6',
  buttonWarningOutlineDisabledFontColor: 'Warning-3',
  buttonWarningOutlineDisabledBackgroundColor: 'transparent',
  buttonWarningOutlineDisabledBorderColor: 'Warning-3',
  buttonWarningOutlineHoverFontColor: 'Warning-5',
  buttonWarningOutlineHoverBackgroundColor: 'transparent',
  buttonWarningOutlineHoverBorderColor: 'Warning-5',
  buttonWarningOutlineActiveFontColor: 'Warning-7',
  buttonWarningOutlineActiveBackgroundColor: 'transparent',
  buttonWarningOutlineActiveBorderColor: 'Warning-7',
  buttonWarningOutlineFocusFontColor: 'Warning-5',
  buttonWarningOutlineFocusBackgroundColor: 'transparent',
  buttonWarningOutlineFocusBorderColor: 'Warning-5',
  buttonWarningTextFontColor: 'Warning-6',
  buttonWarningTextBackgroundColor: 'Transparent',
  buttonWarningTextBorderColor: 'Transparent',
  buttonWarningTextDisabledFontColor: 'Warning-3',
  buttonWarningTextDisabledBackgroundColor: 'Transparent',
  buttonWarningTextDisabledBorderColor: 'Transparent',
  buttonWarningTextHoverFontColor: 'Warning-5',
  buttonWarningTextHoverBackgroundColor: 'Neutral-fill-2',
  buttonWarningTextHoverBorderColor: 'Neutral-fill-2',
  buttonWarningTextActiveFontColor: 'Warning-6',
  buttonWarningTextActiveBackgroundColor: 'Neutral-fill-3',
  buttonWarningTextActiveBorderColor: 'Neutral-fill-3',
  buttonWarningTextFocusFontColor: 'Warning-5',
  buttonWarningTextFocusBackgroundColor: 'Neutral-fill-2',
  buttonWarningTextFocusBorderColor: 'Neutral-fill-2',
  buttonDangerFontColor: 'Neutral-text-1',
  buttonDangerBackgroundColor: 'Danger-6',
  buttonDangerBorderColor: 'Danger-6',
  buttonDangerDisabledFontColor: 'Neutral-text-1',
  buttonDangerDisabledBackgroundColor: 'Danger-3',
  buttonDangerDisabledBorderColor: 'Danger-3',
  buttonDangerHoverFontColor: 'Neutral-text-1',
  buttonDangerHoverBackgroundColor: 'Danger-5',
  buttonDangerHoverBorderColor: 'Danger-5',
  buttonDangerActiveFontColor: 'Neutral-text-1',
  buttonDangerActiveBackgroundColor: 'Danger-7',
  buttonDangerActiveBorderColor: 'Danger-7',
  buttonDangerFocusFontColor: 'Neutral-text-1',
  buttonDangerFocusBackgroundColor: 'Danger-5',
  buttonDangerFocusBorderColor: 'Danger-5',
  buttonDangerOutlineFontColor: 'Danger-6',
  buttonDangerOutlineBackgroundColor: 'transparent',
  buttonDangerOutlineBorderColor: 'Danger-6',
  buttonDangerOutlineDisabledFontColor: 'Danger-3',
  buttonDangerOutlineDisabledBackgroundColor: 'transparent',
  buttonDangerOutlineDisabledBorderColor: 'Danger-3',
  buttonDangerOutlineHoverFontColor: 'Danger-5',
  buttonDangerOutlineHoverBackgroundColor: 'transparent',
  buttonDangerOutlineHoverBorderColor: 'Danger-5',
  buttonDangerOutlineActiveFontColor: 'Danger-7',
  buttonDangerOutlineActiveBackgroundColor: 'transparent',
  buttonDangerOutlineActiveBorderColor: 'Danger-7',
  buttonDangerOutlineFocusFontColor: 'Danger-5',
  buttonDangerOutlineFocusBackgroundColor: 'transparent',
  buttonDangerOutlineFocusBorderColor: 'Danger-5',
  buttonDangerTextFontColor: 'Danger-6',
  buttonDangerTextBackgroundColor: 'Transparent',
  buttonDangerTextBorderColor: 'Transparent',
  buttonDangerTextDisabledFontColor: 'Danger-3',
  buttonDangerTextDisabledBackgroundColor: 'Transparent',
  buttonDangerTextDisabledBorderColor: 'Transparent',
  buttonDangerTextHoverFontColor: 'Danger-5',
  buttonDangerTextHoverBackgroundColor: 'Neutral-fill-2',
  buttonDangerTextHoverBorderColor: 'Neutral-fill-2',
  buttonDangerTextActiveFontColor: 'Danger-6',
  buttonDangerTextActiveBackgroundColor: 'Neutral-fill-3',
  buttonDangerTextActiveBorderColor: 'Neutral-fill-3',
  buttonDangerTextFocusFontColor: 'Danger-5',
  buttonDangerTextFocusBackgroundColor: 'Neutral-fill-2',
  buttonDangerTextFocusBorderColor: 'Neutral-fill-2',
  buttonLinkFontColor: 'Brand-6',
  buttonLinkBackgroundColor: 'transparent',
  buttonLinkBorderColor: 'transparent',
  buttonLinkDisabledFontColor: 'Brand-3',
  buttonLinkDisabledBackgroundColor: 'transparent',
  buttonLinkDisabledBorderColor: 'transparent',
  buttonLinkHoverFontColor: 'Brand-5',
  buttonLinkHoverBackgroundColor: 'transparent',
  buttonLinkHoverBorderColor: 'transparent',
  buttonLinkActiveFontColor: 'Brand-7',
  buttonLinkActiveBackgroundColor: 'transparent',
  buttonLinkActiveBorderColor: 'transparent',
  buttonLinkFocusFontColor: 'Brand-5',
  buttonLinkFocusBackgroundColor: 'transparent',
  buttonLinkFocusBorderColor: 'transparent',
  buttonFontSize: 'Font-14',
  buttonBorderRadius: 'Radius-default',
  buttonPaddingX: 'Spacing-12',
  buttonPaddingY: 'Spacing-4',
  buttonHeight: 'Size-16',
  buttonFontWeight: 'Weight-regular',
  buttonSmallFontSize: 'Font-12',
  buttonSmallBorderRadius: 'Radius-default',
  buttonSmallPaddingX: 'Spacing-8',
  buttonSmallPaddingY: 'Spacing-1',
  buttonSmallHeight: 'Size-12',
  buttonSmallFontWeight: 'Weight-regular',
  buttonLargeFontSize: 'Font-16',
  buttonLargeBorderRadius: 'Radius-default',
  buttonLargePaddingX: 'Spacing-16',
  buttonLargePaddingY: 'Spacing-7',
  buttonLargeHeight: 'Size-20',
  buttonLargeFontWeight: 'Weight-regular',
  buttonPrimarySplitBackgroundColor: 'Neutral-fill-1',
  buttonPrimarySplitDisabledBackgroundColor: 'Neutral-fill-1',
  buttonPrimarySplitHoverBackgroundColor: 'Neutral-fill-1',
  buttonPrimarySplitActiveBackgroundColor: 'Neutral-fill-1',
  buttonPrimarySplitFocusBackgroundColor: 'Neutral-fill-1',
  buttonPrimaryOutlineSplitBackgroundColor: 'Brand-6',
  buttonPrimaryOutlineSplitDisabledBackgroundColor: 'Brand-3',
  buttonPrimaryOutlineSplitHoverBackgroundColor: 'Brand-5',
  buttonPrimaryOutlineSplitActiveBackgroundColor: 'Brand-7',
  buttonPrimaryOutlineSplitFocusBackgroundColor: 'Brand-5',
  buttonPrimaryTextSplitBackgroundColor: 'Neutral-border-1',
  buttonPrimaryTextSplitDisabledBackgroundColor: 'Neutral-border-1',
  buttonPrimaryTextSplitHoverBackgroundColor: 'Neutral-border-1',
  buttonPrimaryTextSplitActiveBackgroundColor: 'Neutral-border-1',
  buttonPrimaryTextSplitFocusBackgroundColor: 'Neutral-border-1',
  buttonSecondarySplitBackgroundColor: 'Neutral-border-1',
  buttonSecondarySplitDisabledBackgroundColor: 'Neutral-border-1',
  buttonSecondarySplitHoverBackgroundColor: 'Neutral-fill-5',
  buttonSecondarySplitActiveBackgroundColor: 'Neutral-fill-6',
  buttonSecondarySplitFocusBackgroundColor: 'Neutral-fill-5',
  buttonSecondaryOutlineSplitBackgroundColor: 'Neutral-border-2',
  buttonSecondaryOutlineSplitDisabledBackgroundColor: 'Brand-3',
  buttonSecondaryOutlineSplitHoverBackgroundColor: 'Brand-5',
  buttonSecondaryOutlineSplitActiveBackgroundColor: 'Brand-7',
  buttonSecondaryOutlineSplitFocusBackgroundColor: 'Brand-5',
  buttonSecondaryTextSplitBackgroundColor: 'Neutral-border-1',
  buttonSecondaryTextSplitDisabledBackgroundColor: 'Neutral-border-1',
  buttonSecondaryTextSplitHoverBackgroundColor: 'Neutral-border-1',
  buttonSecondaryTextSplitActiveBackgroundColor: 'Neutral-border-1',
  buttonSecondaryTextSplitFocusBackgroundColor: 'Neutral-border-1',
  buttonSuccessSplitBackgroundColor: 'Neutral-fill-1',
  buttonSuccessSplitDisabledBackgroundColor: 'Neutral-fill-1',
  buttonSuccessSplitHoverBackgroundColor: 'Neutral-fill-1',
  buttonSuccessSplitActiveBackgroundColor: 'Neutral-fill-1',
  buttonSuccessSplitFocusBackgroundColor: 'Neutral-fill-1',
  buttonSuccessOutlineSplitBackgroundColor: 'Success-5',
  buttonSuccessOutlineSplitDisabledBackgroundColor: 'Success-3',
  buttonSuccessOutlineSplitHoverBackgroundColor: 'Success-4',
  buttonSuccessOutlineSplitActiveBackgroundColor: 'Success-6',
  buttonSuccessOutlineSplitFocusBackgroundColor: 'Success-4',
  buttonSuccessTextSplitBackgroundColor: 'Neutral-border-1',
  buttonSuccessTextSplitDisabledBackgroundColor: 'Neutral-border-1',
  buttonSuccessTextSplitHoverBackgroundColor: 'Neutral-border-1',
  buttonSuccessTextSplitActiveBackgroundColor: 'Neutral-border-1',
  buttonSuccessTextSplitFocusBackgroundColor: 'Neutral-border-1',
  buttonWarningSplitBackgroundColor: 'Neutral-fill-1',
  buttonWarningSplitDisabledBackgroundColor: 'Neutral-fill-1',
  buttonWarningSplitHoverBackgroundColor: 'Neutral-fill-1',
  buttonWarningSplitActiveBackgroundColor: 'Neutral-fill-1',
  buttonWarningSplitFocusBackgroundColor: 'Neutral-fill-1',
  buttonWarningOutlineSplitBackgroundColor: 'Warning-5',
  buttonWarningOutlineSplitDisabledBackgroundColor: 'Warning-3',
  buttonWarningOutlineSplitHoverBackgroundColor: 'Warning-4',
  buttonWarningOutlineSplitActiveBackgroundColor: 'Warning-6',
  buttonWarningOutlineSplitFocusBackgroundColor: 'Warning-4',
  buttonWarningTextSplitBackgroundColor: 'Neutral-border-1',
  buttonWarningTextSplitDisabledBackgroundColor: 'Neutral-border-1',
  buttonWarningTextSplitHoverBackgroundColor: 'Neutral-border-1',
  buttonWarningTextSplitActiveBackgroundColor: 'Neutral-border-1',
  buttonWarningTextSplitFocusBackgroundColor: 'Neutral-border-1',
  buttonDangerSplitBackgroundColor: 'Neutral-fill-1',
  buttonDangerSplitDisabledBackgroundColor: 'Neutral-fill-1',
  buttonDangerSplitHoverBackgroundColor: 'Neutral-fill-1',
  buttonDangerSplitActiveBackgroundColor: 'Neutral-fill-1',
  buttonDangerSplitFocusBackgroundColor: 'Neutral-fill-1',
  buttonDangerOutlineSplitBackgroundColor: 'Danger-5',
  buttonDangerOutlineSplitDisabledBackgroundColor: 'Danger-3',
  buttonDangerOutlineSplitHoverBackgroundColor: 'Danger-4',
  buttonDangerOutlineSplitActiveBackgroundColor: 'Danger-6',
  buttonDangerOutlineSplitFocusBackgroundColor: 'Danger-4',
  buttonDangerTextSplitBackgroundColor: 'Neutral-border-1',
  buttonDangerTextSplitDisabledBackgroundColor: 'Neutral-border-1',
  buttonDangerTextSplitHoverBackgroundColor: 'Neutral-border-1',
  buttonDangerTextSplitActiveBackgroundColor: 'Neutral-border-1',
  buttonDangerTextSplitFocusBackgroundColor: 'Neutral-border-1',
  buttonRoundBorderRadius: 'Radius-full',
  buttonCircleBorderRadius: 'Radius-circle',
  buttonCircleSize: 'Size-16',
  buttonSquareBorderRadius: 'Radius-default',
  buttonSmallRoundBorderRadius: 'Radius-full',
  buttonSmallCircleBorderRadius: 'Radius-circle',
  buttonSmallCircleSize: 'Size-12',
  buttonSmallSquareBorderRadius: 'Radius-default',
  buttonLargeRoundBorderRadius: 'Radius-full',
  buttonLargeCircleBorderRadius: 'Radius-circle',
  buttonLargeCircleSize: 'Size-20',
  buttonLargeSquareBorderRadius: 'Radius-default',
  buttonNearlyMargin: 'Spacing-8',
  buttonSpinMargin: 'Spacing-4',
};

export default buttonTokens;
